import {
  AfterViewChecked,
  AfterViewInit,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subject, takeUntil} from "rxjs";
import {NgForOf, NgIf} from "@angular/common";
import {ProgressComponent} from "../../progress/progress.component";
import {DistributionBarComponent} from "../../distribution-bar/distribution-bar.component";
import {SvgIconComponent} from "../../svg-icon/svg-icon.component";
import {HasCloseEvent} from "../../../interfaces/has-close-event.interface";
import { IdNameModel } from '../../../models/idname.model';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-options',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    ProgressComponent,
    DistributionBarComponent,
    NgIf,
    SvgIconComponent,
    TranslocoDirective
  ],
  templateUrl: './options.component.html',
  styleUrl: './options.component.scss'
})
export class OptionsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy, HasCloseEvent {
  @Input() public title: string = "";
  @Input() public hint: string = "";
  @Input() public data: IdNameModel[] = [];
  @Output() public selectedChange: EventEmitter<IdNameModel> = new EventEmitter<IdNameModel>();
  @Output() public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('search') searchField!: ElementRef;

  protected searchForm = new FormGroup({searchInput: new FormControl<string>('')});
  protected filteredOptions: IdNameModel[] = [];
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.filteredOptions = [...this.data];
    this.searchForm.valueChanges.pipe(
      takeUntil(this.destroy$)).subscribe(({searchInput}) => {
      if (searchInput) {
        this.filteredOptions = this.data.filter(o => o.name.toLowerCase().includes(searchInput.toLowerCase()!));
      } else {
        this.filteredOptions = [...this.data];
      }

    });
  }

  ngAfterViewInit() {
    this.searchField.nativeElement.focus();
  }

  ngAfterViewChecked() {
    this.highLightMatches(this.searchForm.controls.searchInput.value)
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  protected selectAndClose(selected: IdNameModel) {
    this.selectedChange.emit(selected);
    this.closeEvent.emit(true);
  }

  protected clear() {
    this.searchForm.reset();
  }

  private highLightMatches(searchInput: string | null | undefined) {
    const startSubString = '<b>';
    const endSubString = '</b>';
    document.querySelectorAll('.option-container .item').forEach(li => {
      let text = li.innerHTML.replace(startSubString, '').replace(endSubString, '');
      if (searchInput) {
        let startIndex = text.toLowerCase().indexOf(searchInput.toLowerCase());
        let endIndex = startIndex + searchInput.length;

        text = text.substring(0, startIndex) + startSubString + text.substring(startIndex, endIndex) + endSubString + text.substring(endIndex);
      }
      li.innerHTML = text;
    });
  }
}
